exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/core-js/library/modules/_wks-ext.js
// module id = 197
// module chunks = 1